import DatabaseService from '@/services/database'
import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: '',
  checkDB: '',
  tables: [],
  newtables: {},
  isLoading: false,
  databaseIsAlready: true
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error,
  getTestConnection: state => state.checkDB,
  getTables: state => state.tables,
  getTablesWithParam: state => state.tables,
  getTableWithConnects: state => state.newtables,
  getDatabaseIsAlready: state => state.databaseIsAlready
}

// mutations
const mutations = {
  setData(state, {
    data,
    total
  }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    const tempData = state.data
    tempData.push(model)
    Vue.set(state, 'data', tempData)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    if (!model || !model.id) return
    const index = state.data.findIndex(m => m && m.id === model.id)
    if (index === -1) return
    state.data[index] = model
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  setError(state, error) {
    state.error = error
  },
  testConnection(state, checkDB) {
    state.checkDB = checkDB
  },
  getTables(state, tables) {
    state.tables = tables
  },
  getTablesWithParam(state, tables) {
    state.tables = tables
  },
  getTableWithConnects(state, tables) {
    state.newtables = tables
  },
  loading(state) {
    state.isLoading = true
  },
  checkDatabaseName(state, isAlready) {
    state.databaseIsAlready = isAlready
  },

  replaceDatabase(state, database) {
    if (!database || !database.id) return
    const index = state.data.findIndex(m => m && m.id === database.id)
    if (index === -1) return
    state.data[index] = database
  }
}

const actions = {
  databaseAll({
    commit,
    state
  }) {
    return DatabaseService.databaseAll().then((res) => {
      commit('setData', {
        data: res.result,
        total: res.paginate.total
      })
    })
  },
  listAll({
    commit,
    state
  }) {
    return DatabaseService.listAll().then((res) => {
      commit('setData', {
        data: res.result,
        total: res.paginate.total
      })
    })
  },
  findAll({
    commit,
    state
  }, options) {
    return DatabaseService.findAll(options).then((res) => {
      commit('setData', {
        data: res.result,
        total: res.paginate.total
      })
    })
  },
  save({
    commit,
    state
  }, model) {
    if (!model.id) {
      return DatabaseService.create(model).then((res) => {
        if (res.result) {
          commit('appendData', res.result)
        } else {
          commit('setError', res.response)
        }
      })
    } else {
      return DatabaseService.update(model).then((res) => {
        // Some successful update endpoints return only code/status without a
        // result object. Keep the submitted model as the updated store value.
        commit('updateData', (res && res.result) || model)
      })
    }
  },
  delete({
    commit,
    state
  }, id) {
    return DatabaseService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  },
  testConnect({
    commit,
    state
  }, model) {
    return DatabaseService.testConnection(model).then((res) => {
      if (res.status === 'success') {
        commit('setError', '')
        commit('testConnection', res.result)
      } else {
        commit('setError', res.response)
      }
    })
  },
  getTables({
    commit,
    state
  }, id) {
    return DatabaseService.getTables(id).then((res) => {
      if (res.status === 'success') {
        commit('setError', '')
        const result = res.result
        commit('getTables', result)
      } else {
        commit('setError', res.response)
      }
    })
  },
  getTablesWithParam({
    commit,
    state
  }, params) {
    let data = []
    const index = state.data.findIndex(m => m.id === params.id)
    switch (params.typeSource) {
      case 'stored_procedure':
        data = state.data[index].store_pcds
        // data = state.selectedDatabase.store_pcds
        break
      case 'view':
        data = state.data[index].views
        // data = state.selectedDatabase.views
        break
      default:
        data = state.data[index].tables
        // data = state.selectedDatabase.tables
        break
    }
    commit('getTables', data)
  },
  getTableWithConnects({
    commit,
    state
  }, model) {
    return DatabaseService.getTablesWithConnect(model).then((res) => {
      if (res.status === 'success') {
        commit('setError', '')
        commit('getTableWithConnects', res.result)
      } else {
        commit('setError', res.response)
      }
    })
  },
  checkDatabaseName({
    commit,
    state
  }, name) {
    return DatabaseService.checkDatabaseName(name).then((res) => {
      commit('checkDatabaseName', res)
      return res
    })
  },
  updateElasticDatabase({ commit, state }, model) {
    return DatabaseService.updateElasticDatabase(model).then((res) => {
    })
  },

  replaceDatabase({
    commit,
    state
  }, database) {
    commit('replaceDatabase', database)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
